import { GetBackgroundStyle } from "@talladega/helpers";
import { FinancingCalculatorLayout } from "@modules/cms/types/FinancingCalculatorLayout";
import useConsumerFinancingFromQuery from "@modules/purchase/consumer/hooks/useConsumerFinancingFromQuery";
import useVehicleFinancePricingDefaults from "@modules/purchase/consumer/hooks/useVehicleFinancePricingDefaults";
import { useRouter } from "next/router";
import FinancingCalculator from "./FinancingCalculator";
import {
  getFirstStep,
  getStepPathname,
} from "../../types/ConsumerFinancingStep";

type Props = {
  layout: FinancingCalculatorLayout;
};

const FinancingCalculatorWrapper = ({ layout }: Props) => {
  const { year } = useConsumerFinancingFromQuery();
  const { pricingDefaults, isFetched } = useVehicleFinancePricingDefaults(year);
  const { background } = layout;
  const {
    push,
    query: { source },
  } = useRouter();

  const onStartFinancing = () => {
    const firstStep = getFirstStep();
    push({
      pathname: getStepPathname(firstStep),
      query: { source },
    });
  };

  return (
    <div
      id="cms-financing-calculator-section"
      className="bg-white overflow-visible no-scrollbar relative bg-cover bg-center"
      style={GetBackgroundStyle(
        background,
        process.env.NEXT_PUBLIC_CLOUDFLARE_IMAGES_DOMAIN || ""
      )}
    >
      <div className="relative max-w-page mx-auto flex flex-col items-center justify-center py-6 px-4 lg:px-5 lg:py-16">
        {isFetched && (
          <FinancingCalculator
            pricingDefaults={pricingDefaults}
            onStartFinancing={onStartFinancing}
            cmsProps={layout}
          />
        )}
      </div>
    </div>
  );
};

export default FinancingCalculatorWrapper;
